import React from 'react'
import { useState, useEffect } from 'react'
import { useKhmdUpdateSaveMutation } from '../../store/BnsKeJiApi'
import {Modal, Form, Input, App } from 'antd'
function ContactEdit(props) {
    const {message} = App.useApp()
    const [open, setOpen] = useState(false)
    const [form] = Form.useForm()
    const [submitUpdateSave] = useKhmdUpdateSaveMutation()
    const [info,setInfo] = useState({
        khmd_phone: props.khmd_phone,   
        khmd_content: props.khmd_content,
        khmd_uid: props.eu_id,
        khmd_uname: props.eu_name,
        khmd_id: props.khmd_id
    })
    useEffect(() => {
        if(open){
            form.setFieldsValue({
                khmd_phone: props.khmd_phone,
                khmd_content: props.khmd_content
            })
        }
    },[open,props.khmd_phone,props.khmd_content,form])
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                open={open}
                title='修改客户'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    submitUpdateSave(info).then((res) => {
                        if(res.data.Status === 'success'){
                            message.success('修改成功！')
                            setInfo({
                                khmd_phone: '',
                                khmd_content: '',
                                khmd_uid: props.eu_id,
                                khmd_uname: props.eu_name
                            })
                            setOpen(false)
                            form.resetFields()
                        }else{
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form 
                    form={form}
                    layout="horizontal"
                    name={`form_contact_edit_${props.khmd_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 7 }}
                >  
                    <Form.Item 
                        label="手机号码/微信号" 
                        name="khmd_phone" 
                        rules={[{ required: true, message: '请输入手机号码' }]}
                    >
                        <Input onChange={(e) => {setInfo(prevState=>({...prevState,khmd_phone:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item label="备注" name="khmd_content" rules={[{ required: true, message: '请输入备注' }]}>
                        <Input onChange={(e) => {setInfo(prevState=>({...prevState,khmd_content:e.target.value}))}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ContactEdit